import { SubPart } from "../api/type"
import { cleanTopicsString } from "./Helper"

export const parseSubPartLabels = (text: string): string[] =>
  cleanTopicsString(text)
    .split(",")
    .map((label) => label.trim().replace(/^\((.*)\)$/, "$1"))
    .filter(Boolean)

export const buildSubParts = (text: string, existing: SubPart[] = []): SubPart[] =>
  parseSubPartLabels(text).map((label) => {
    const match = existing.find((part) => part.label === label)
    return (
      match ?? {
        label,
        question: "",
        answer: "",
        solution: "",
        marks: null,
        marking_scheme: "",
      }
    )
  })

export const formatSubPartsLabels = (subParts?: SubPart[]) =>
  (subParts ?? []).map((part) => part.label).join(", ")
